// @flow
export { default } from './CategoryMenuBoxItem';



// WEBPACK FOOTER //
// ./src/components/categories/CategoryMenuBoxItem/index.js